import { atom } from "recoil"

/**
 * 未読返信数の強制リフレッシュをトリガーするためのatom
 * 値をインクリメントすることで、useIncrementalUnreadCountに再取得を促す
 */
export const forceRefreshUnreadCountState = atom<number>({
  key: "forceRefreshUnreadCountState",
  default: 0,
})
